"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useQuestions = useQuestions;
const react_1 = require("react");
const stores_1 = require("../stores/index.js");
const view_models_1 = require("../../view-models/index.js");
function useQuestions() {
    const questions = (0, stores_1.useCalculatorStore)((state) => state.data.questions);
    return (0, react_1.useMemo)(() => (0, view_models_1.questionsViewModel)(questions), [questions]);
}
